<template>
  <v-card hover :loading="calls.length == 0" tile ref="call-list">
    <v-card-title>Llamadas recientes</v-card-title>
    <v-simple-table fixed-header>
      <thead>
        <tr>
          <th class="text-left">Duración</th>
          <th class="text-left">Fecha</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in calls" :key="item.idCall">
          <td>{{ item.durationStr }} min(s)</td>
          <td>{{ date(item.callStart) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CallsList",

  computed: {
    ...mapGetters({
      calls: "getCalls"
    })
  },

  methods: {
    date(date) {
      const d = new Date(date);
      return `${d.getDate()}/${d.getMonth() +
        1}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    },

    ...mapActions(["seeCalls"])
  },

  async mounted() {
    this.seeCalls();

    this.$emit("intro", {
      id: 3,
      name: "call-list",
      element: this.$refs["call-list"].$el,
      str: "Mira la información básica de las 5 últimas llamadas.",
      step: 3
    });
  }
};
</script>
